<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <div class="md-layout text-center">
        <div class="md-layout-item md-size-33 md-small-size-100 tagline">
          <h2><b>HomeGaroo</b></h2>
          <h3>
            <b>
              <span class="material-icons">
                engineering
              </span>
              Unfortunately, we are still under development and don't offer any
              services yet. Check us again soon!
            </b>
          </h3>
          <h4>
            <b>
              Need to contact us? Email us at j.peshev@homegaroo.nl or
              m.garkov@homegaroo.nl.
            </b>
          </h4>

          <!-- <h2><b>HomeGaroo</b></h2>
            <h3>
            <b>
                Fast. Convenient. Reliable.
            </b>
            </h3>
            <h4>
            <b>
                Everything you or your home might need in one single platform:
                cooking, construction, dog walking, cleaning, locksmith and so
                much more. Now made easy, join us and find for yourslelf.
            </b>
            </h4> -->
        </div>
        <div class="md-layout-item md-size-10 md-small-size-100"></div>
        <div
          class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
        >
          <login-card class="login-card" header-color="accent">
            <h3 slot="title" class="title">Log in</h3>
            <md-button
              slot="buttons"
              href="#facebook"
              class="md-just-icon md-simple md-white"
            >
              <i class="fab fa-facebook-square"></i>
            </md-button>
            <md-button
              slot="buttons"
              href="#twitter"
              class="md-just-icon md-simple md-white"
            >
              <i class="fab fa-twitter"></i>
            </md-button>
            <md-button
              slot="buttons"
              href="#google"
              class="md-just-icon md-simple md-white"
            >
              <i class="fab fa-google-plus-g"></i>
            </md-button>
            <div slot="inputs">
              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ passed, failed }"
              >
                <md-field
                  class="md-form-group"
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>email</md-icon>
                  <label>Email</label>
                  <md-input v-model="email" type="email"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div slot="inputs">
              <ValidationProvider
                name="password"
                rules="required|min:4"
                v-slot="{ passed, failed }"
              >
                <md-field
                  class="md-form-group"
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>lock_outline</md-icon>
                  <label>Password</label>
                  <md-input v-model="password" type="password"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <router-link
              slot="footer"
              :to="{ name: 'PasswordRecovery' }"
              class="md-simple md-button md-layout-item"
              ><a class="forgot-password">forgot password?</a>
            </router-link>
            <div
              slot="footer"
              class="md-round md-accent md-lg md-layout-item md-size-30"
            ></div>
            <md-button
              type="submit"
              slot="footer"
              class="md-round md-accent md-lg md-layout-item md-size-35"
            >
              Lets Go
            </md-button>
          </login-card>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { LoginCard } from "@/components";
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import { SlideYDownTransition } from "vue2-transitions";
import { logIn } from "@/api/auth.service";

extend("email", email);
extend("required", required);
extend("min", min);

export default {
  components: {
    LoginCard,
    SlideYDownTransition
  },
  data() {
    return {
      email: null,
      password: null
    };
  },
  methods: {
    submit() {
      logIn(this.email, this.password)
        .then(_ => {
          this.$router.push({ name: "User Page" });
        })
        .catch(() => {
          this.$toasted.error("Check your credentials and try again", {
            position: "top-center"
          });
        });
    }
  }
};
</script>

<style>
.login-card {
  max-width: 100% !important;
}
.md-form-group {
  margin-top: 3vh;
  margin-bottom: 1vh;
}
.md-button {
  font-weight: bold;
  font-size: large;
}
.forgot-password {
  padding: 1vh;
  font-weight: normal !important;
  font-size: small !important;
}
</style>
